export default __webpack_public_path__ + "static/media/shareLeft.2beb991e.png";